<template>
  <div class="space-y-6">
    <div class="h-full max-h-64 overflow-y-auto rounded-md shadow-md">
      <div>
        <div
          class="grid grid-cols-5 bg-ontick-steel-100 text-center text-sm text-ontick-steel-900 dark:bg-ontick-steel-500 dark:text-gray-300"
        >
          <div class="th col-span-3 pl-3 text-left">Estratégia</div>
          <!-- <th class="th">Perda Máx.</th>
          <th class="th">Ganho Máx.</th> -->
          <div class="th">Vol.</div>
          <div class="th"></div>
        </div>
        <div
          v-if="portfolioConfigs"
          class="divide-y divide-ontick-steel-100 dark:divide-ontick-steel-500"
        >
          <div
            class="grid grid-cols-5 text-center text-xs text-ontick-steel-900 dark:text-gray-300"
            v-for="item in portfolioConfigs"
            :key="item.strategy_id"
          >
            <div class="td col-span-3 pl-3 text-left">
              {{ item.strategy_name }} {{ item.strategy_symbol }}
            </div>

            <div class="td">
              {{ item.volume }}
            </div>
            <div class="td flex items-center justify-center px-3">
              <div
                is="transition"
                v-on:enter="enter"
                v-on:leave="leave"
                v-bind:css="false"
                appear
                mode="out-in"
              >
                <div
                  :key="item.status"
                  v-html="
                    item.status == 'success'
                      ? $icons.success2
                      : item.status == 'error'
                      ? $icons.error
                      : item.status == 'start'
                      ? $icons.loading
                      : pause
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      portfolioConfigs: undefined,
      pause:
        "<div class='dark:bg-ontick-steel-500 bg-ontick-steel-100 w-5 h-5 rounded-full'></div>",
    };
  },

  props: {
    investments_ids: { type: Array },
    investmentId: { type: Number },
    account_id: { type: Number },
    running_success: { type: Boolean },
  },

  created() {
    this.listPorfolio(this.account_id, this.investmentId, this.paramId);
  },
  computed: {
    ...mapState({
      color: (state) => state.investment.color,
    }),
    ...mapGetters({
      getParameters: "investment/getParameters",
      getSelectedParameters: "investment/getSelectedParameters",
    }),
    paramId() {
      return this.getParameters.selectedParameter.param_id;
    },
  },
  watch: {
    running_success(value) {
      if (value) {
        this.verifyPortfolio(this.investments_ids);
      }
    },
    paramId(val) {
      this.listPorfolio(this.account_id, this.investmentId, val);
    },
  },

  methods: {
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        autoAlpha: 0,
        rotationY: 90,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.5, {
        autoAlpha: 1,
        rotationY: 0,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.to(el, 0.5, {
        scale: 0,
        ease: Power4.easeOut,
        onComplete: done,
      });
    },

    listPorfolio(account_id, investment_id) {
      return this.$api
        .get(
          `${this.$endpoint.GET_INVESTMENT_PORTFOLIO}/${account_id}/${investment_id}`,
          {
            params: {
              param_id: this.getParameters.selectedParameter.param_id,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          this.portfolioConfigs = response.data;
          this.portfolioConfigs.forEach((item) => {
            this.$set(item, "status", null);
          });
        });
    },

    verifyPortfolio(ids) {
      // let promises = [];

      this.portfolioConfigs.forEach((item) => {
        item.status = "start";
      });
      let has_error = false;

      for (let i = 0; i < ids.length; i++) {
        let param = {
          portfolio_id: this.investmentId,
          investment_id: ids[i],
          account_id: this.account_id,
        };
        setTimeout(
          () => {
            this.$api
              .post(this.$endpoint.STATUS_INVESTMENT_PORTFOLIO, param)
              .then(() => {
                var index = this.portfolioConfigs.findIndex(
                  (x) => Number(x.investment_id) == ids[i]
                );
                if (index != -1) {
                  this.$set(this.portfolioConfigs[index], "status", "success");
                }
              })
              .catch((error) => {
                console.log(error);
                var index = this.portfolioConfigs.findIndex(
                  (x) => Number(x.investment_id) == ids[i]
                );
                if (index != -1) {
                  this.portfolioConfigs[index].status = "error";
                  has_error = true;
                }
              });
          },
          i * 750,
          has_error
        );
      }

      setTimeout(() => {
        if (has_error) {
          this.portfolioConfigs.forEach((item) => {
            item.status = "error";
          });

          setTimeout(() => {
            this.$swal({
              title: "Erro ao tentar inicializar o portfólio",
              icon: "error",
              timer: 4000,
            });
            this.$emit("close");
          }, (ids.length + 2) * 750);
        } else {
          this.$emit("success");
        }
      }, (ids.length + 2) * 750);

      // Promise.all(promises).then(() => console.log(this.portfolioConfigs));
    },

    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
  },
};
</script>
<style lang="scss" scoped>
.th,
.td {
  @apply py-2;
}
</style>
